export const TOOLS = {
  DECOMPOSE_QUERY: "decompose_query",
  RETRIEVE_LEGAL_DOCS: "retrieve_legal_documents_with_metadata",
  FIND_LEGAL_SOURCES: "find_legal_sources",
  LIST_DOCUMENTS: "list_documents",
  READ_DOCUMENT_RANGE: "read_document_range",
  REPLACE_TEXT: "replace_text",
  FS_NAVIGATE: "fs_navigate",
  FS_READ_SLICE: "fs_read_slice",
  FS_CREATE_FILE: "fs_create_file",
} as const;

export type ToolName = (typeof TOOLS)[keyof typeof TOOLS];
